<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            إدارة الموارد البشرية والحوكمة
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            الروابط مع مكتب الصحة في المديرية والمحافظة
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-workforce')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">4/9</div>
          <div class="kpi-label">مرافق لديها سياسة HR مكتوبة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">3/9</div>
          <div class="kpi-label">مرتبطة بـ DHO رسمياً</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">6/9</div>
          <div class="kpi-label">تعاني تأخر في الرواتب</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">2/9</div>
          <div class="kpi-label">لديها نظام حوافز</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">حوكمة الموارد البشرية</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>ملاك رسمي مُعتمد؟</th>
            <th>التنسيق مع DHO</th>
            <th>تأخر الرواتب؟</th>
            <th>سياسة التقييم السنوي</th>
            <th>نظام حوافز</th>
            <th>الانضباط والغياب</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="chipColor(item.officialStaff)"
                size="small"
                variant="flat"
                >{{ item.officialStaff }}</v-chip
              >
            </td>
            <td>{{ item.dhoCoordination }}</td>
            <td>
              <v-chip
                :color="salaryDelayColor(item.salaryDelay)"
                size="small"
                variant="flat"
                >{{ item.salaryDelay }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.annualEvaluation)"
                size="small"
                variant="flat"
                >{{ item.annualEvaluation }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.incentives)"
                size="small"
                variant="flat"
                >{{ item.incentives }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="disciplineColor(item.discipline)"
                size="small"
                variant="flat"
                >{{ item.discipline }}</v-chip
              >
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    officialStaff: "كامل",
    dhoCoordination: "منتظم",
    salaryDelay: "نعم",
    annualEvaluation: "جزئي",
    incentives: "لا يوجد",
    discipline: "جزئي",
  },
  {
    name: "مستشفى الأمراض النفسية",
    officialStaff: "جزئي",
    dhoCoordination: "غير منتظم",
    salaryDelay: "نعم",
    annualEvaluation: "لا يوجد",
    incentives: "لا يوجد",
    discipline: "ضعيف",
  },
  {
    name: "مجمع الشيخ عثمان",
    officialStaff: "كامل",
    dhoCoordination: "منتظم",
    salaryDelay: "جزئي",
    annualEvaluation: "جزئي",
    incentives: "جزئي",
    discipline: "جيد",
  },
  {
    name: "مركز كود العثماني",
    officialStaff: "لا يوجد",
    dhoCoordination: "نادر",
    salaryDelay: "نعم",
    annualEvaluation: "لا يوجد",
    incentives: "لا يوجد",
    discipline: "ضعيف",
  },
  {
    name: "مركز الممدارة",
    officialStaff: "كامل",
    dhoCoordination: "منتظم",
    salaryDelay: "لا",
    annualEvaluation: "كامل",
    incentives: "جزئي",
    discipline: "جيد",
  },
  {
    name: "مركز المحاريق",
    officialStaff: "جزئي",
    dhoCoordination: "غير منتظم",
    salaryDelay: "نعم",
    annualEvaluation: "لا يوجد",
    incentives: "لا يوجد",
    discipline: "متوسط",
  },
  {
    name: "مركز عبد القوي",
    officialStaff: "كامل",
    dhoCoordination: "منتظم",
    salaryDelay: "لا",
    annualEvaluation: "كامل",
    incentives: "جزئي",
    discipline: "جيد",
  },
  {
    name: "مركز ماري ستبوس",
    officialStaff: "لا يوجد",
    dhoCoordination: "غائب",
    salaryDelay: "نعم",
    annualEvaluation: "لا يوجد",
    incentives: "لا يوجد",
    discipline: "ضعيف",
  },
  {
    name: "جمعية حقوق الطفل",
    officialStaff: "جزئي",
    dhoCoordination: "جزئي",
    salaryDelay: "نعم",
    annualEvaluation: "لا يوجد",
    incentives: "لا يوجد",
    discipline: "متوسط",
  },
];

const chipColor = (value) => {
  if (value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const salaryDelayColor = (value) => {
  if (value === "لا") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const disciplineColor = (value) => {
  if (value === "جيد") return "green";
  if (value === "متوسط" || value === "جزئي") return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
